import { routerReducer } from 'react-router-redux';
import localeReducer from './locale/reducer';


export default ({
    routerReducer,
    locale: localeReducer,
});
